import { render, staticRenderFns } from "./ReviewChart.html?vue&type=template&id=5acecb16&scoped=true&external"
import script from "./ReviewChart.ts?vue&type=script&lang=ts&external"
export * from "./ReviewChart.ts?vue&type=script&lang=ts&external"
import style0 from "./ReviewChart.scss?vue&type=style&index=0&id=5acecb16&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acecb16",
  null
  
)

export default component.exports